import React, { useState, useEffect } from "react";
import { Link as ScrollLegacyLink } from "react-scroll";
import logo from "./../../images/logo-big-shop.png";
import { NavLink as RouterLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";


// import {Link} from 'react-scroll'

function Navbar2({ forceSmallHeader = false }) {
  const [navToggle, setnavToggle] = useState(true);
  const [isMobile, setIsMobile] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(max-width: 768px)").matches
  );
  const [showServicesList, setShowServicesList] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const apply = () => {
      setIsMobile(mq.matches);
      if (!mq.matches) setShowServicesList(false);
    };
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else mq.addListener(apply);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", apply);
      else mq.removeListener(apply);
    };
  }, []);

  useEffect(() => {
    if (forceSmallHeader) return;
    const onScroll = () => setIsScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [forceSmallHeader]);

  const small = forceSmallHeader || isScrolled;
  // Desktop: the open side navigation uses icons only; fixed/compact bars show labels.
  const iconsOnly = !isMobile && !small;
  const showRotatedLabels = !isMobile && !small;

  const onServicesClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      setShowServicesList((v) => !v);
    }
  };

  return (
    <>
      {/* Layout2-only submenu rules */}
      {forceSmallHeader && (
        <style>{`
          /* prevent clipping in fixed header */
          .header-top-fixed.force-small-header .header-body,
          .header-top-fixed.force-small-header .header-body-fixed { overflow: visible !important; }

          .navbar.is-layout2 { position: relative; z-index: 9999; }
          .navbar.is-layout2 .service { position: relative; z-index: 1; }

          /* ===== LEFT-ALIGNED solid submenu panel ===== */
          .navbar.is-layout2 .service > .sub-menu-container{
            position:absolute;
            top:calc(100% + 10px);
            left:0;                /* anchor to left of "MISSION" */
            right:auto;
            transform:none;
            display:none;          /* desktop default */
            padding:12px;
            min-width:300px;
            max-width:min(520px, 88vw);
            border-radius:14px;
            border:1px solid rgba(255,255,255,.16);
            box-shadow:0 20px 50px rgba(0,0,0,.32);
            background:rgba(0,0,0,.72) !important; /* theme-proof */
            z-index:100000;
            isolation:isolate;     /* for ::after layer stacking */
          }

          /* Kept only as a backing layer; the scrollable panel itself owns the background. */
          .navbar.is-layout2 .service > .sub-menu-container::after{
            content:"";
            position:absolute; inset:0;
            border-radius:14px;
            background:transparent;
            z-index:-1;
          }

          /* caret aligned to link's left padding */
          .navbar.is-layout2 .service > .sub-menu-container::before{
            content:"";
            position:absolute;
            top:-8px; left:24px;
            width:14px; height:14px;
            transform:rotate(45deg);
            background:rgba(0,0,0,.72);
            border-left:1px solid rgba(255,255,255,.16);
            border-top:1px solid rgba(255,255,255,.16);
            z-index:0;
          }

          /* show rules */
          .navbar.is-layout2 .service:hover > .sub-menu-container{ display:block; }
          .navbar.is-layout2 .service.sub-open > .sub-menu-container{ display:block; }

          /* list + links */
          .navbar.is-layout2 .service > .sub-menu-container .sub-menu-list{ list-style:none; margin:0; padding:4px 0; }
          .navbar.is-layout2 .service > .sub-menu-container .sub-menu-list > li{ margin:0; }
          .navbar.is-layout2 .service > .sub-menu-container .sub-menu-list > li > a{
            display:block; padding:10px 12px;
            color:#ffffff; text-decoration:none; border-radius:10px;
            transition:background 160ms ease, color 160ms ease; white-space:nowrap;
          }
          .navbar.is-layout2 .service > .sub-menu-container .sub-menu-list > li > a:hover,
          .navbar.is-layout2 .service > .sub-menu-container .sub-menu-list > li > a:focus{
            background:rgba(255,255,255,.12); color:#ffffff;
          }

          /* mobile: full-width block under item */
          @media (max-width:768px){
            .navbar.is-layout2 .service > .sub-menu-container{
              position:static; left:auto; right:auto; transform:none;
              width:100%; max-width:none; box-shadow:none; border-radius:10px; margin-top:8px;
            }
            .navbar.is-layout2 .service > .sub-menu-container::before{ display:none; }
          }
          /* ===== Nested Submenu Styling ===== */

.navbar.is-layout2 .has-submenu {
  position: relative;
  padding: 8px 12px;   /* increase vertical padding */
  
}


.navbar.is-layout2 .sub-sub-menu {
  list-style: none;
  padding-left: 15px;
  margin-top: 6px;     /* add separation from title */
}

.navbar.is-layout2 .sub-sub-menu li a {
  display: block;
  padding: 8px 10px;
  font-size: 14px;
  border-radius: 6px;
  text-decoration: none;
}

.navbar.is-layout2 .sub-sub-menu li a:hover {
  background: rgba(255,255,255,.12);
  color: #ffffff;
}
          
        `}</style>
      )}

      <nav
        className={`navbar navbar-default navbar-expand-md ${
          small ? "navbar-small" : "navbar-full"
        } ${forceSmallHeader ? "is-layout2" : ""} ${iconsOnly ? "nav-icons-only" : ""}`}
      >
        <div className="navbar-header">
          <RouterLink to="/" className="header-logo">
            <img
              height={forceSmallHeader ? "210px" : "110px"}
              src={logo}
              alt="logo"
            />
          </RouterLink>

          <button
            onClick={() => setnavToggle(!navToggle)}
            type="button"
            className="navbar-toggle"
            data-bs-toggle="collapse"
            data-bs-target="#bs-example-navbar-collapse-1"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
        </div>

        <div
          className={
            navToggle ? "collapse navbar-collapse" : "collapse navbar-collapse show"
          }
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav  navbar-right menu-item-8" id="navbar-full">
           <li className="current home">
  <span className="bg-icon">
    <i className="ion-person-stalker"></i>
  </span>

  {showRotatedLabels && (
    <span className="rotated-title effect">
      <strong className="nav-title-lines">Legislative<br />lobbying</strong>
    </span>
  )}

  <RouterLink
    to="/legislative-lobbying"
    className="link-item"
    aria-label="Legislative"
    onClick={() => setShowServicesList(false)}
  >
    {iconsOnly ? null : "Legislative"}
  </RouterLink>
</li>



<li className="about ab2">
  <span className="bg-icon">
    <i className="ion-university"></i>
  </span>
  {showRotatedLabels && (
    <span className="rotated-title effect"><strong className="nav-title-lines">Grassroots<br />Advocacy</strong></span>
  )}

  <RouterLink
    to="/grassroots-advocacy"
    aria-label="Advocacy"
    onClick={() => setShowServicesList(false)}
  >
    {iconsOnly ? null : "Advocacy"}
  </RouterLink>
</li>

<li className="about ab2">
  <span className="bg-icon">
    <i className="ion-ios-people"></i>
  </span>
  {showRotatedLabels && (
    <span className="rotated-title effect"><strong className="nav-title-lines">Govt. Relations<br />Program</strong></span>
  )}

  <RouterLink
    to="/government-relations"
    aria-label="Relations"
    onClick={() => setShowServicesList(false)}
  >
    {iconsOnly ? null : "Relations"}
  </RouterLink>
</li>

<li className="about ab2">
  <span className="bg-icon">
    <i className="ion-ribbon-a"></i>
  </span>
  {showRotatedLabels && (
    <span className="rotated-title effect"><strong className="nav-title-lines">Issue-Based<br />Campaigns</strong></span>
  )}

  <RouterLink
    to="/issue-based-campaigns"
    aria-label="Campaigns"
    onClick={() => setShowServicesList(false)}
  >
    {iconsOnly ? null : "Campaigns"}
  </RouterLink>
</li>
<li className="about ab2">
  <span className="bg-icon">
    <i className="ion-ribbon-a"></i>
  </span>
  {showRotatedLabels && (
    <span className="rotated-title effect"><strong className="nav-title-lines">Public Policy<br />Communications</strong></span>
  )}

  <RouterLink
    to="/public-policy-communications"
    aria-label="Communications"
    onClick={() => setShowServicesList(false)}
  >
    {iconsOnly ? null : "Communications"}
  </RouterLink>
</li>
<li className="about ab2">
  <span className="bg-icon">
    <i className="ion-ribbon-a"></i>
  </span>
  {showRotatedLabels && (
    <span className="rotated-title effect"><strong className="nav-title-lines">Advocacy<br />Pipeline</strong></span>
  )}

  <RouterLink
    to="/research-to-advocacy"
    aria-label="Pipeline"
    onClick={() => setShowServicesList(false)}
  >
    {iconsOnly ? null : "Pipeline"}
  </RouterLink>
</li>
<li className="about ab2">
  <span className="bg-icon">
    <i className="ion-ribbon-a"></i>
  </span>
  {showRotatedLabels && (
    <span className="rotated-title effect"><strong className="nav-title-lines">Advocacy<br />Infrastructure</strong></span>
  )}

  <RouterLink
    to="/advocacy-membership"
    aria-label="Infrastructure"
    onClick={() => setShowServicesList(false)}
  >
    {iconsOnly ? null : "Infrastructure"}
  </RouterLink>
</li>


<li className="contact orange-transparent">
  <span className="bg-icon">
                <i className="ion-cash"></i>
              </span>

  {showRotatedLabels && (
    <span className="rotated-title effect"><strong>Donate</strong></span>
  )}

  <a
    href=""
    className="link-item"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Donate"
    onClick={() => setShowServicesList(false)}
  >
    {iconsOnly ? null : "Donate"}
  </a>
</li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar2;
